<template>
  <div class="body-container" id="app">
    <theme />
    <!--vue-progress-bar></!--vue-progress-bar-->
    <!-- v-if="!isHome || !IsWebView" -->
    <router-view name="header" id="header" transparent="true" />
    <div class="wrapper">
      <router-view />
      <!--router-view name="dialog"></router-view-->
    </div>
    <router-view name="footer" id="footer" v-if="!isHome || !IsWebView()" />
    <notifications group="bottomRight" position="bottom right" animation-type="velocity" />
    <notifications group="topRight" width="300px" position="top right" animation-type="velocity" />
    <notifications group="topCenter" width="300px" position="top center" animation-type="velocity" />
    <div @click="redirectToTracking" v-if="showTrackingButton">
      <fab fab-icon="k-icon-order-tracker"></fab>
    </div>
    <download-app-modal ref="downloadAppModal" :business="business" v-if="business" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { subdomain } from "@/utilities";
import { IsWebView } from "@/utilities/helper";
import { Fab } from "@/components";
import { DownloadAppModal } from "@/views/modals";
import { Theme } from "@/views/partial";
import { isAndroid } from "mobile-device-detect";
import orderTackerMixin from "@/mixins/orderTrackerMixin";
export default {
  metaInfo() {
    return {
      title: `${this.business
          ? `${this.business.name} | What The Fork`
          : "What The Fork"
        }`,
      meta: [
        { charset: "utf-8" },
        {
          name: "description",
          content: this.business
            ? this.business.description
            : "What The Fork are the only online ordering system for restaurants and takeaways with table ordering that provide a capped cost feature.",
        },
        {
          name: "viewport",
          content:
            "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=1, shrink-to-fit=no",
        },
        { property: "og:locale", content: "en_GB" },
        { property: "og:type", content: "website" },
        {
          property: "og:title",
          content: `${this.business
              ? `${this.business.name} | What The Fork`
              : "What The Fork"
            }`,
        },
        {
          property: "og:description",
          content: this.business
            ? this.business.description
            : "What The Fork are the only online ordering system for restaurants and takeaways with table ordering that provide a capped cost feature.",
        },
        {
          property: "og:url",
          content: `https://${subdomain.get()}.whatthefork.app`,
        },
        {
          property: "og:site_name",
          content: `${this.business ? this.business.name : "What The Fork"} `,
        },
        {
          property: "twitter:title",
          content: `${this.business
              ? `${this.business.name} | What The Fork`
              : "What The Fork"
            }`,
        },
        {
          property: "twitter:description",
          content: this.business
            ? this.business.description
            : "What The Fork are the only online ordering system for restaurants and takeaways with table ordering that provide a capped cost feature.",
        },
        {
          property: "twitter:site",
          content: `https://${subdomain.get()}.whatthefork.app`,
        },
        { property: "twitter:creator", content: "@WhatTheForkApp" },
      ],
    };
  },
  mixins: [orderTackerMixin],
  components: {
    Fab,
    DownloadAppModal,
    Theme
  },
  computed: {
    ...mapState('locationStore', ['channel']),
    ...mapState('userStore', ['guestData']),
    isHome() {
      return this.$route.name === "home";
    },
    showTrackingButton() {
      return (
        this.$route.name === "home" && this.user && this.getTrackedOrder.length
      );
    },
  },
  data() {
    return {
      IsWebView,
      position: "bottom-right",
      fabActions: [
        {
          name: "cache",
          icon: "cached",
        },
        {
          name: "alertMe",
          icon: "add_alert",
        },
      ],
    };
  },
  methods: {
    ...mapActions('locationStore', [ "saveTrackedOrder"]),
    ...mapActions('userStore', ["logoutRequest", "fetchAuthUser"]),
    logout() {
      this.logoutRequest();
    },
    redirectToTracking() {
      this.$router.push({
        name: "tracking-order",
        params: { id: this.getTrackedOrder[0].id },
      });
    },
    showFourWaysDownloadModal() {
      if (subdomain.get() != "fourwayskirkliston") return; //show this modal onnly for fourwayskirkliston
      if (IsWebView() && isAndroid && this.channel != 6) {
        // 6 is User-App Android
        this.$refs.downloadAppModal.openModal();
      }
    },
  },
  mounted() {
    this.showFourWaysDownloadModal();

    if(!this.isAuthenticated && localStorage.getItem('user-token')){
      this.fetchAuthUser()
    }
  },
};
</script>
